type Props = {
	size?: number
}

const CheckboxCheckedIcon = ({ size = 14 }: Props) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<rect x="3" y="3" width="18" height="18" rx="2" />
		<path d="m9 12 2 2 4-4" />
	</svg>
)

export default CheckboxCheckedIcon
